<template>
  <div :class="{ active: isActive }" class="custom-message-container">
    <div
      v-for="(i, index) in getMaxLength"
      :key="index"
      :style="{ 'margin-left': siderWidth + 'px' }"
      :class="{ active: messages[index].active }"
      class="row"
    >
      <span class="content">
        {{ messages[index].content }}
      </span>
      <span class="ctrl">
        <a-icon class="ctrl-icon" type="close-circle" @click="close(index)" />
      </span>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import XO9ActiveFeature from '@G/mixins/XO9ActiveFeature'
export default {
  name: 'CustomMessage',
  mixins: [XO9ActiveFeature],
  data() {
    return {
      maxLength: 5,
      isActive: false,
      // contents: ['1', '12', '13', '14', '15', '16', '17', '18'],
      messages: [],
      siderWidth: 0,
      storageName: 'message_opened'
    }
  },
  computed: {
    getMaxLength() {
      const max = this.maxLength
      return this.messages.length > max ? max : this.messages.length
    },
    ...mapGetters(['systemMessages'])
  },
  watch: {
    async systemMessages(messages) {
      if (messages) {
        this.messages = messages.map(row => {
          return {
            ...row,
            active: true
          }
        })
        this.handleOpenMessage()
      }
    }
  },
  mounted() {
    this.setContainerLayout()
  },
  methods: {
    ...mapActions([_GM.REMOVE_MESSAGE]),
    close(index) {
      if (this.systemMessages.length === 1) {
        this.isActive = false
      }
      this.messages[this.getMaxLength - 1].active = false
      this.$nextTick(async () => {
        this[_GM.REMOVE_MESSAGE](index)
      })
    },
    handleOpenMessage() {
      this.isActive = true
    },
    setContainerLayout() {
      const sider = document.querySelector('.ant-layout-sider')
      this.siderWidth = sider.clientWidth
      const resizeObserver = new ResizeObserver(() => {
        this.siderWidth = sider.clientWidth
      })
      resizeObserver.observe(sider)
    }
  }
}
</script>
<style lang="scss">
.custom-message-container {
  pointer-events: none;
  position: fixed;
  top: 0;
  margin: auto;
  width: 100%;
  left: 0;
  padding: 0 12px;
  z-index: 9999;
  transition: all 0.2s ease-out;
  opacity: 0;
  &.active {
    opacity: 0.8;
    top: 60px;
  }
  .row {
    border-radius: 5px;
    box-shadow: rgba(0, 0, 0, 0.8) 1px 1px 3px;
    background: #000;
    color: #fff;
    position: relative;
    pointer-events: auto;
    display: flex;
    flex-wrap: nowrap;
    align-items: stretch;
    margin-top: 10px;
    &.active {
      animation-name: animate-in;
      animation-duration: 0.6s;
    }
  }
  .content,
  .ctrl {
    padding: 4px 10px;
  }
  .content {
    flex: 1 1 95%;
    text-align: center;
    word-break: break-all;
  }
  .ctrl {
    flex: 1 1 20px;
    text-align: right;
    .ctrl-icon {
      cursor: pointer;
    }
  }
  @keyframes animate-in {
    from {
      margin-top: 40px;
      opacity: 0;
    }
    to {
      margin-top: 10px;
      opacity: 1;
    }
  }
}
</style>
